import React from 'react'
import { NextButton } from '../common/CommonStyled'
import { usePromoresultStore } from 'src/stores/PromoStore'
import { patchPromotion } from 'src/api/Promo'
import { format } from 'date-fns'
import { PromoResultType } from 'src/pages/PromoResultPage';
import { useDialogStore } from 'src/stores/DialogStore'

interface Props{
  school_class: string;
  result_id :number;
  setTab : React.Dispatch<React.SetStateAction<PromoResultType>>;
}

const ButtonResultModify = ({school_class,result_id,setTab}:Props) => {
    const visited_date = usePromoresultStore((state)=>state.visit_date)
    const total_count = usePromoresultStore((state)=>state.total_cnt)
    const attendee_cnt = usePromoresultStore((state)=>state.attendee_cnt)
    const apply_cnt = usePromoresultStore((state)=>state.apply_cnt)
    const content = usePromoresultStore((state)=>state.content)
    const setField = useDialogStore((state)=>state.setField)

    const isAttendeeValid = (Number(total_count)>=Number(attendee_cnt)) ? true:false

    const isDisabled =
    !visited_date ||
    !total_count ||
    !attendee_cnt ||
    !isAttendeeValid;

    const handleResultAdd = async()=>{
        
        const fromat_date = format(visited_date, 'yyyy-MM-dd');

        await patchPromotion(
            {result_id:result_id,
              total_cnt: total_count,
              attendee_cnt: attendee_cnt,
              apply_cnt: apply_cnt,
              visit_date: fromat_date,
              content: content,
              is_reviewed: true,
              school_class: school_class
            }
        )
        setField('response_data',[])
        setField('page_Num',1)
        setTimeout(() => {
        setTab('home');
      }, 300); // 0.3초 정도 UI 상태 갱신 대기
        // setTab('home')
    }

  return (
    <NextButton onClick={()=>handleResultAdd()} disabled={isDisabled}>적용</NextButton>
  )
}

export default ButtonResultModify